import React from 'react';
import { KingBed as HotelIcon, Pin as PinIcon, Restaurant as RestaurantIcon, Departure as AirportIcon } from 'pcln-icons';
import { mapPinType } from '../../constants';
import { Box } from 'pcln-design-system';
const MapIcon = ({
  type
}) => {
  const iconProp = {
    size: 20,
    color: 'text.lightest',
    style: {
      marginTop: '7.5px',
      marginLeft: '8px'
    }
  };
  switch (type) {
    case mapPinType.HOTEL:
      return React.createElement(HotelIcon, Object.assign({}, iconProp));
    case mapPinType.RESTAURANT:
      return React.createElement(RestaurantIcon, Object.assign({}, iconProp));
    case mapPinType.AIRPORT:
      return React.createElement(AirportIcon, Object.assign({}, iconProp));
    default:
      return React.createElement(PinIcon, Object.assign({}, iconProp));
  }
};
export const SinglePinIcon = ({
  type
}) => {
  return React.createElement(Box, {
    bg: 'primary.base',
    width: '36px',
    height: '36px',
    style: {
      borderRadius: '50%'
    }
  }, React.createElement(MapIcon, {
    type: type
  }));
};